import { Controller } from "stimulus";
import { useThrottle, useDispatch, useDebounce } from 'stimulus-use';

export default class extends Controller {
  static targets = ["searchbarContainer", "searchbarPlaceholder"];

  static throttles = ['handleScroll'];
  static debounces = ['handleScrollEnd'];

  connect() {
    useThrottle(this, { wait: 100 });
    useDebounce(this, { wait: 100 });
    useDispatch(this);

    this.scrollDelta = 60;
    this.prevScrollPositionForSearchbar = 0;
    this.prevScrollPositionForHeader = 0;
    this.isSearchbarMiniMode = false;
    this.header = document.querySelector('.header-unit-types');
    this.absoluteSearchbarPosition = this.getAbsoluteSearchbarPosition();
    this.setSearchbarPlaceholderDimensions();
  }

  handleScroll() {
    this.adjustSearchbarAppearance();
    this.adjustHeaderPosition();
    this.adjustHeaderAndSearchbarOnScrollUp();
  }

  handleScrollEnd() {
    this.adjustSearchbarAppearance();
  }

  adjustSearchbarAppearance() {
    const headerHeight = this.header.offsetHeight; 
    const isDesktop = window.innerWidth >= 1200;

    if (isDesktop) {
      // Desktop: Fix when top of searchbar reaches bottom of header
      if (window.scrollY + headerHeight >= this.absoluteSearchbarPosition - this.searchbarContainerTarget.offsetHeight) {
        this.fixSearchbar();
        this.handleSearchbarMiniMode();
      } else {
        this.unfixSearchbar();
        this.handleSearchbarNormalMode();
      }
    } else {
      // Mobile: Fix when bottom of searchbar reaches bottom of header
      if (window.scrollY + headerHeight >= this.absoluteSearchbarPosition - 300) {
        this.fixSearchbar();
        // this.handleSearchbarMiniMode();
      } else {
        this.unfixSearchbar();
        // this.handleSearchbarNormalMode();
      }
      if (
        window.scrollY + headerHeight >=
        this.absoluteSearchbarPosition - 100
      ) {
        this.handleSearchbarMiniMode();

      } else {
        this.handleSearchbarNormalMode();
      }
    }
  }

  adjustHeaderPosition() {
    const headerHeight = this.header.offsetHeight;
    const isDesktop = window.innerWidth >= 1200;

    if (isDesktop) {
      if (window.scrollY + headerHeight >= this.absoluteSearchbarPosition - this.searchbarContainerTarget.offsetHeight) {
        this.dispatchHeaderEvents("unfixHeader");
      } else {
        this.dispatchHeaderEvents("fixHeader");
      }
    } else {
      if (window.scrollY + headerHeight >= this.absoluteSearchbarPosition - 300) {
        this.dispatchHeaderEvents("unfixHeader");
      } else {
        this.dispatchHeaderEvents("fixHeader");
      }
    }
  }

  adjustHeaderAndSearchbarOnScrollUp() {
    if (window.scrollY < this.prevScrollPositionForHeader) {
      this.dispatchHeaderEvents("fixHeader");
      this.searchbarContainerTarget.classList.add('under-header');
    } else {
      this.searchbarContainerTarget.classList.remove('under-header');
    }
    this.prevScrollPositionForHeader = window.scrollY;
  }

  getAbsoluteSearchbarPosition() {
    let absoluteY = 0;
    let currentElement = this.searchbarContainerTarget;

    while (currentElement.offsetParent !== null) {
      absoluteY += currentElement.offsetTop;
      currentElement = currentElement.offsetParent;
    }

    return absoluteY + this.searchbarContainerTarget.offsetHeight;
  }

  setSearchbarPlaceholderDimensions() {
    const { width, height } = this.searchbarContainerTarget.getBoundingClientRect();
    this.searchbarPlaceholderTarget.style.width = `${width}px`;
    this.searchbarPlaceholderTarget.style.height = `${height}px`;
  }

  fixSearchbar() {
    this.searchbarContainerTarget.classList.add('fixed');
    this.searchbarPlaceholderTarget.classList.remove('hidden');
  }

  unfixSearchbar() {
    this.searchbarContainerTarget.classList.remove('fixed');
    this.searchbarPlaceholderTarget.classList.add('hidden');
  }

  setSearchbarMiniModeFlag() {
    this.isSearchbarMiniMode = true;
  }

  resetSearchbarMiniModeFlag() {
    this.isSearchbarMiniMode = false;
    this.prevScrollPositionForSearchbar = window.scrollY;
  }

  handleSearchbarMiniMode() {
    if (this.isSearchbarMiniMode) return;

    if (Math.abs(window.scrollY - this.prevScrollPositionForSearchbar) > this.scrollDelta) {
      this.dispatch('searchbarMini');
      this.isSearchbarMiniMode = true;
    }
  }

  handleSearchbarNormalMode() {
    if (!this.isSearchbarMiniMode) return;

    this.dispatch('searchbarNormal');
    this.isSearchbarMiniMode = false;
  }

  dispatchHeaderEvents(event) {
    window.dispatchEvent(new CustomEvent(event));
  }
}
